import React, { createContext, useState } from "react";

export const PassCodeContext = createContext();

export function PassCodeProvider({ children }) {
  const [authorized, setAuthorized] = useState(false);

  return (
    <PassCodeContext.Provider value={{ authorized, setAuthorized }}>
      {children}
    </PassCodeContext.Provider>
  );
}